import React, { Component } from 'react';

import Checkbox from '../../common/checkbox/main';

export default class Checkboxes extends Component {
  state = {
    checkedItems: {'lg-1': true, 'lg-2': true, 'lg-3': true, 'sm-3': true},
    largeCheckboxItems: [{key: 'lg-1', copy: 'pizza steve'}, {key:'lg-2', copy: 'hippopotamus'}, {key: 'lg-3', copy: 'things that are blue'}],
    mediumCheckboxItems: [{key: 'md-1', copy: 'mountain'}, {key: 'md-2', copy: 'flummoxed'}, {key: 'md-3', copy: 'purple pants'}, {key: 'md-4', copy: 'unicorn'}],
    selectAllChecked: {sm: 'partially-selected', md: false, lg: true},
    sizeMap: {sm: 'smallCheckboxItems', md: 'mediumCheckboxItems', lg: 'largeCheckboxItems'},
    smallCheckboxItems: [{key: 'sm-1', copy: 'rino beer garden'}, {key: 'sm-2', copy: 'pants party'}, {key: 'sm-3', copy: 'iphone'}, {key: 'sm-4', copy: 'rubber duck'}]
  }


  updateSelectAll = (clickedItem) => {
    const {checkedItems, selectAllChecked, sizeMap} = this.state;
    const clickedItemSize = clickedItem.split('-')[0];
    const checkedItemsQty = Object.keys(checkedItems).filter(item => item.split('-')[0] === clickedItemSize).length;
    const checkboxItems = this.state[sizeMap[clickedItemSize]];
    const checkboxItemsQty = checkboxItems.length;

    if (checkedItemsQty === 0) {
      selectAllChecked[clickedItemSize] = false;
    } else if (checkedItemsQty === checkboxItemsQty) {
      selectAllChecked[clickedItemSize] = true;
    } else if (checkedItemsQty < checkboxItemsQty) {
      selectAllChecked[clickedItemSize] = 'partially-selected';
    }

    this.setState({selectAllChecked});
  }

  toggleCheckbox = (clickedItem) => {
    const {checkedItems} = this.state;

    if (checkedItems[clickedItem]) {
      delete checkedItems[clickedItem];
    } else {
      checkedItems[clickedItem] = true;
    }

    this.setState({checkedItems}, () => this.updateSelectAll(clickedItem));
  }

  toggleCheckboxSelectAll = (checkboxSize) => {
    const {checkedItems, selectAllChecked, sizeMap} = this.state;
    const checkboxItems = this.state[sizeMap[checkboxSize]];

    if (selectAllChecked[checkboxSize] === 'partially-selected' || selectAllChecked[checkboxSize] === false) {
      selectAllChecked[checkboxSize] = true;
      checkboxItems.forEach(item => {
        checkedItems[item.key] ? '' : checkedItems[item.key] = true;
      })
    } else if (selectAllChecked[checkboxSize] === true) {
      selectAllChecked[checkboxSize] = false;
      Object.keys(checkedItems).forEach(checkedItem => {
        checkedItem.split('-')[0] === checkboxSize ? delete checkedItems[checkedItem] : '';
      })
    }

    this.setState({checkedItems, selectAllChecked})
  }

  generateCheckboxes = (size, itemsArray) => {
    const {checkedItems, selectAllChecked} = this.state;
    const checkboxArray = [];
    checkboxArray.push(
      <Checkbox checked={selectAllChecked[size] === 'partially-selected' ? false : selectAllChecked[size]}
                datakey={size}
                key={0}
                labelHtml={<h4>Select All</h4>}
                partiallySelected={selectAllChecked[size] === 'partially-selected' ? 'partially-selected' : ''}
                size={ size }
                toggle={e => this.toggleCheckboxSelectAll(e.target.getAttribute('data-key'))}
      />
    );

    itemsArray.forEach(item => {
      checkboxArray.push(
        <Checkbox checked={checkedItems[item.key] || false}
                  datakey={item.key}
                  key={item.key}
                  labelHtml={<h4>{item.copy}</h4>}
                  size={ size }
                  toggle={e => this.toggleCheckbox(e.target.getAttribute('data-key'))}
        />
      )
    })

    return checkboxArray;
  }

  render () {
    const {largeCheckboxItems, mediumCheckboxItems, smallCheckboxItems} = this.state;

    return (
      <div className='example-container'>
        <div className='checkboxes-container'>
          <div className='small-checkbox-container'>
            <h3 className='checkbox-container-title'>Small Checkboxes</h3>
            {this.generateCheckboxes('sm', smallCheckboxItems)}
          </div>
          <div className='medium-checkbox-container'>
            <h3 className='checkbox-container-title'>Medium Checkboxes</h3>
            {this.generateCheckboxes('md', mediumCheckboxItems)}
          </div>
          <div className='large-checkbox-container'>
            <h3 className='checkbox-container-title'>Large Checkboxes</h3>
            {this.generateCheckboxes('lg', largeCheckboxItems)}
          </div>
        </div>
      </div>
    )
  }
}
